<template>
  <div>
     Sales Reps

    <b-row>
      <b-col sm="3">
         <b-dropdown
           size="sm"
           variant="outline-secondary"
           :text="sel_country || 'Select Country'"
           menu-class="w-100"
         >
           <b-dropdown-item-button
             v-for="opt in country_list"
             :key="opt"
             @click="selectCountry(opt)"
           >
             {{ opt }}
           </b-dropdown-item-button>
         </b-dropdown>
      </b-col>
      <b-col sm="3" v-if="sel_country">
         <b-input size="sm"
          placeholder="Filter"
          v-model="sel_filter"
          v-on:keyup='filterResults'
          >
         </b-input>
      </b-col>
    </b-row>

    <b-row v-if="sel_country">
      <b-col>
        <div v-for="rep in show_reps"
          style="border: solid 1px black;border-radius:0.2rem;margin:0.5rem;">
          <b-row>
            <b-col style="text-align:center;font-weight:bold;">
               Region: {{ rep.rgn }}
            </b-col>
          </b-row>
          <b-row style="text-align:center;font-weight:bold;">
            <b-col sm="6">
               Country
            </b-col>
            <b-col sm="6">
               State/Province/City/etc.
            </b-col>
          </b-row>
          <b-row style="text-align:center;">
            <b-col sm="6">
               {{ rep.cty }}
            </b-col>
            <b-col sm="6">
               {{ rep.ter }}
            </b-col>
          </b-row>
          <b-row style="text-align:center;">
            <b-col>
               <b-button size="sm"
                 variant="success"
                 @click="$parent.goto_room($parent.acc+'/'+rep.room)">
                 Join
               </b-button>
               {{ rep.name }}
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "event_srep",
  data() {
      return {
        reps:[],
        repFields: [
          {key: "ctrl", label: ""},
          {key: "rgn", label: "Region/Territory"},
          {key: "cty", label: "Country"},
          {key: "ter", label: "State/Province/City/etc."},
          {key: "name", label: "Sales Rep"},
        ],
        show_reps: [],
        country_list: [],
        sel_country: "",
        sel_filter: "",
      };
  },
  components: {
  },
  created() {},
  computed: {},
  methods: {
    selectCountry: function(cty) {
      let vue = this;
      vue.sel_country = cty;
      vue.sel_filter = "";
      vue.show_reps = [];
      vue.reps.forEach(function(r) {
         if (!r.cty.includes(cty)) { return; }
         vue.show_reps.push(r);
      });      
    },
    filterResults: function() {
      let vue = this;
      let filter = ""+vue.sel_filter;
      //console.log("filter ["+filter+"]");
      vue.show_reps = [];
      vue.reps.forEach(function(r) {
         if (!r.cty.includes(vue.sel_country)) { return; }
         let regex = new RegExp(filter,'i');
         if (filter &&
             !r.rgn.match(regex) &&
             !r.cty.match(regex) &&
             !r.ter.match(regex)) { return; }
         vue.show_reps.push(r);
      });
    },
    fetch_reps: function() {
      let vue = this;
      window.wss_send_cb(vx, "adm_event_get_part", {
        rtag: "srep",
        event: {
          id: vue.$parent.event.id,
          field: "sreps",
        },
      }, function(msg) {
        vue.reps = [];
        if (!msg || !msg.data || !msg.data.obj) {
          return;
        }
        let reps = msg.data.obj[0];
        if (!reps || !reps.r) { return; }
        reps.r.forEach(function(r) {
          if (!r.em || !r.room) { return; }
          if (!r.valid_em || !r.valid_room) { return; }
          let cty = r.cty.split(";")
          cty.forEach(function(c) {
            if (!vue.country_list.includes(c)) {
              vue.country_list.push(c);
            }
          });
          r.cty = cty.join(", ");
          r.ter = r.ter.split(";").join(", ");
          vue.reps.push(r);
        });
      });
    },
    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      vue.fetch_reps();
    },
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  beforeDestroy() {
  },
  mounted() {
    let vue = this;
    vue.setup();
  },
};
</script>

<style lang="scss" scoped>

</style>
